export class VisaCard {
    public static isVisa(card: string): boolean {
        return card.replace(/\D+/g,'').length === 16 && /^4\d{12}(\d{3})?/.test(card)
    }
}